import React from "react";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const CarouselComponent = (props) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 920 },
      items: 2,
      partialVisibilityGutter: 3
    },
    
    small: {
        breakpoint: { max: 920, min: 0 },
        items: 2,
        partialVisibilityGutter: 1
    }
  };

  const CustomDot = ({ onClick, index, active }) => {
    return <li className={`react-multi-carousel-dot ${active ? 'react-multi-carousel-dot--active' : ''}`}><button aria-label={`ugrás a ${index + 1}. képre`} onClick={onClick}></button></li>;
  };

  return (
    <div className="more-carousel" >
      <Carousel
              customLeftArrow={<button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left" aria-label="Előző kép"></button>}
              customRightArrow={<button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right" aria-label="Következő kép"></button>}
              additionalTransfrom={0} 
              swipeable={true}
              draggable={!window.matchMedia('(max-device-width: 740px)').matches ? false :  true}
              showDots={!window.matchMedia('(max-device-width: 740px)').matches ? true :  false}
              responsive={responsive}
              infinite={true}
              renderArrowsWhenDisabled={true}
              renderDotsOutside={true}
              slidesToSlide={2}
              centerMode={false}
              keyBoardControl={true}
              customTransition={window.matchMedia('(max-device-width: 400px)').matches ? "transform 100ms ease-in-out" : "transform 1000ms ease-in-out"}
              transitionDuration={window.matchMedia('(max-device-width: 400px)').matches ? 100 : 1000}
              containerClass="carousel-container"
              removeArrowOnDeviceType={["small"]}
              dotListClass="custom-dot-list-style"
              itemClass="carousel-item-padding-40-px"
              customDot={<CustomDot />}
      >
        {props.gallery.map((k,n) => {
            return(
              <div tabIndex="0" onKeyDown={(e) => { if (e.key === 'Enter') props.openLightboxlick(n); }} className={" image-items px-1 pb-3"} key={n} onClick={() => props.openLightboxlick(n)}>
                <img className="gallery-image" src={k.imageUrl !== undefined ? k.imageUrl : k.image} alt={k.imageTitle ? k.imageTitle : (k.title ? k.title : 'galéria kép')}/>
              </div>
        )})}
      </Carousel>
    </div>


  );
};

export default CarouselComponent;
